import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { unit } = measures

export const logo = css`
  width: ${6 * unit}px;
`

export const container = css`
  display: flex;

  align-items: center;

  justify-content: center;
`
